import React, { ReactNode, useState } from 'react'
import styled, { keyframes, css } from 'styled-components'
import { Flex, Text, ChevronDownIcon, FlexProps } from 'vvs-uikit'
import useTheme from 'hooks/useTheme'

const expandAnimation = keyframes`
  from {
    max-height: 0px;
  }
  to {
    max-height: 500px;
  }
`

const collapseAnimation = keyframes`
  from {
    max-height: 500px;
  }
  to {
    max-height: 0px;
  }
`

const Container = styled(Flex)<{ expanded }>`
  background: white;
  animation: ${({ expanded }) =>
    expanded
      ? css`
          ${expandAnimation} 300ms linear forwards
        `
      : css`
          ${collapseAnimation} 300ms linear forwards
        `};
  overflow: hidden;
  width: 100%;
  flex-direction: column;
`
type CollapseItemPropsType = {
  children: ReactNode
  title: string
}

const ArrowIcon = styled(ChevronDownIcon)<{ toggled: boolean }>`
  transform: ${({ toggled }) => (toggled ? 'rotate(180deg)' : 'rotate(0)')};
  height: 35px;
  width: 35px;
`

const Header = styled(Text)`
  font-size: 20px;
  font-weight: 500;
  align-self: center;
`
const ContentWrapper = styled(Flex)`
  padding: 24px;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  background: ${({ theme }) => theme.colors.backgroundAlt2};
  color: ${({ theme }) => theme.colors.textSubtle};
`

const OuterWrapper = styled(Flex)`
  background: ${({ theme }) => theme.card.background};

  ${({ theme }) => theme.mediaQueries.xxl} {
    max-width: 770px;
  }
`

const CollapseItem = (props: CollapseItemPropsType & FlexProps) => {
  const [isExpand, setIsExpand] = useState(false)
  const { children, title, ...restProps } = props
  const { theme } = useTheme()
  return (
    <OuterWrapper flexDirection="column">
      <Flex onClick={() => setIsExpand(!isExpand)} justifyContent="space-between" padding="24px">
        <Header>{title}</Header>
        <ArrowIcon color="primary" toggled={isExpand} />
      </Flex>
      <Container expanded={isExpand} {...restProps}>
        <ContentWrapper>
          <pre style={{ whiteSpace: 'pre-wrap', color: theme.isDark ? theme.colors.text : '#60605F' }}>{children}</pre>
        </ContentWrapper>
      </Container>
    </OuterWrapper>
  )
}

export default CollapseItem
